module.exports = __webpack_public_path__ + "img/34_6.85c7e8a0.png";